import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getProducts = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/products?' + params.toString()); // Let the error bubble up
};

const getProductById = async (id: number) => {
  return await apiClient.get(`/products/${id}`); // Fetch car listing by ID
};

const createProduct = async (productData: any) => {
  return await apiClient.post('/products', productData); // Create a new car listing
};

const updateProduct = async (id: number, productData: any) => {
  return await apiClient.patch(`/products/${id}`, productData); // Update car listing by ID
};

const deleteProduct = async (id: number) => {
  return await apiClient.delete(`/products/${id}`); // Delete car listing by ID
};

const getSuggestedPrice = async (filters: string) => {
  return apiClient.get('/product_prices?' + filters);
};

export default {
  getProducts,
  getProductById,
  createProduct,
  updateProduct,
  deleteProduct,
  getSuggestedPrice
};
